(function(){
  const selector='.ns-paint-nav>details,.ns-uniform-nav__details';
  const closeOthers=current=>document.querySelectorAll(selector).forEach(details=>{if(details!==current)details.open=false;});
  document.addEventListener('click',event=>{
    const summary=event.target.closest('summary');
    if(summary&&summary.parentElement.matches(selector)){
      const details=summary.parentElement;
      event.preventDefault();event.stopImmediatePropagation();
      const open=!details.open;closeOthers(details);details.open=open;
      summary.setAttribute('aria-expanded',String(open));
      return;
    }
    document.querySelectorAll(selector).forEach(details=>{if(!details.contains(event.target))details.open=false;});
  },true);
  document.addEventListener('mouseover',event=>{
    if(!matchMedia('(min-width:769px) and (hover:hover)').matches)return;
    const details=event.target.closest(selector);
    if(details&&!details.contains(event.relatedTarget)){closeOthers(details);details.open=true;details.querySelector('summary').setAttribute('aria-expanded','true');}
  });
  document.addEventListener('mouseout',event=>{
    if(!matchMedia('(min-width:769px) and (hover:hover)').matches)return;
    const details=event.target.closest(selector);
    if(details&&!details.contains(event.relatedTarget)&&!details.contains(document.activeElement)){details.open=false;details.querySelector('summary').setAttribute('aria-expanded','false');}
  });
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const details=event.target.closest(selector);if(details){details.open=false;details.querySelector('summary').focus();}});
  document.documentElement.setAttribute('data-ns-menu-ready','true');
})();
